import Vue from 'vue';
import Router from 'vue-router';

/**
 * General dependencies.
 */
import Blank from '@/layout/Blank';
import Sidebar from '@/layout/Sidebar';
import Document from '@/view/Document';
import Default from '@/layout/Default';
import Dashboard from '@/view/Dashboard';
import Transaction from '@/view/Transaction';

/**
 * Auth dependencies.
 */
import Auth from '@/layout/Auth';
import AuthLogin from '@/view/Auth/Login';
import AuthSignup from '@/view/Auth/Signup';

/**
 * Financier dependencies.
 */
import FinancierLimit from '@/view/Financier/Limit';
import FinancierOrder from '@/view/Financier/Order';
import FinancierExtract from '@/view/Financier/Extract';

/**
 * Account dependencies.
 */
import AccountBank from '@/view/Account/Bank';
import AccountForm from '@/view/Account/Form';
import AccountAudit from '@/view/Account/Audit';
import AccountProfile from '@/view/Account/Profile';

/**
 * Wallet dependencies.
 */
import Wallet from '@/view/Wallet';
import WalletShow from '@/view/Wallet/Show';
import WalletSend from '@/view/Wallet/Send';
import WalletDeposit from '@/view/Wallet/Deposit';

/**
 * Help dependencies.
 */
import Help from '@/layout/Help';
import HelpTerms from '@/view/Help/Terms';
import HelpPrivacy from '@/view/Help/Privacy';

/**
 * Install Vue Router.
 */
Vue.use(Router);

/**
 * Auth routes.
 */
const auth = {
  path: '/auth/',
  component: Auth,
  redirect: '/auth/login',
  children: [
    {
      path: 'login',
      component: AuthLogin,
      meta: {
        to: '/auth/signup',
        label: 'CADASTRE-SE',
        cta: 'Ainda não tenho conta.',
      },
    },
    {
      path: 'signup',
      component: AuthSignup,
      meta: {
        to: '/auth/login',
        label: 'ENTRAR',
        cta: 'Já tenho uma conta.',
      },
    },
  ],
};

/**
 * Financier routes.
 */
const financier = {
  path: 'financeiro/',
  component: Sidebar,
  redirect: 'financeiro/extrato',
  meta: {
    links: [
      {
        label: 'Extrato',
        to: '/financeiro/extrato',
      },
      {
        label: 'Ordens',
        to: '/financeiro/ordens',
      },
      {
        label: 'Limites operacionais',
        to: '/financeiro/limites-operacionais',
      },
    ],
  },
  children: [
    {
      path: 'extrato',
      component: FinancierExtract,
    },
    {
      path: 'ordens',
      component: FinancierOrder,
    },
    {
      path: 'limites-operacionais',
      component: FinancierLimit,
    },
  ],
};

/**
 * Account routes.
 */
const account = {
  path: 'conta/',
  component: Sidebar,
  redirect: 'conta/dados-da-conta',
  meta: {
    links: [
      {
        label: 'Dados da conta',
        to: '/conta/dados-da-conta',
      },
      {
        label: 'Contas Bancárias',
        to: '/conta/contas-bancarias',
      },
      {
        label: 'Segurança',
        to: '/conta/seguranca',
      },
    ],
  },
  children: [
    {
      path: 'dados-da-conta',
      component: AccountProfile,
    },
    {
      path: 'contas-bancarias/',
      component: AccountBank,
      children: [
        {
          path: 'adicionar',
          component: AccountForm,
        },
        {
          path: ':bank_id/editar',
          component: AccountForm,
        },
      ],
    },
    {
      path: 'seguranca',
      component: AccountAudit,
    },
  ],
};

/**
 * Transaction routes.
 */
const transaction = {
  path: 'negociar',
  component: Blank,
  children: [
    {
      path: '',
      component: Transaction,
    },
    {
      path: 'pro',
      component: Transaction,
      meta: {
        pro: true,
      },
    },
  ],
};

/**
 * Help routes.
 */
const help = {
  path: 'atendimento',
  redirect: 'atendimento/politica-de-privacidade',
  meta: {
    links: [
      {
        label: 'Política de Privacidade',
        to: '/atendimento/politica-de-privacidade',
      },
      {
        label: 'Termos de Uso',
        to: '/atendimento/termos-de-uso',
      },
    ],
  },
  component: Help,
  children: [
    {
      path: 'politica-de-privacidade',
      component: HelpPrivacy,
    },
    {
      path: 'termos-de-uso',
      component: HelpTerms,
    },
  ],
};

/**
 * Wallet routes.
 */
const wallet = {
  path: 'carteira/',
  component: Wallet,
  children: [
    {
      path: 'enviar',
      component: WalletSend,
    },
    {
      path: 'receber',
      component: WalletDeposit,
    },
    {
      path: ':id',
      props: true,
      component: WalletShow,
    },
  ],
};

/**
 * Main routes.
 */
const main = {
  path: '/',
  component: Default,
  children: [
    {
      path: '',
      redirect: '/auth/login',
    },

    {
      path: 'dashboard',
      component: Dashboard,
    },

    transaction,

    wallet,

    financier,

    account,

    help,

    {
      path: 'documentos',
      component: Document,
      meta: {
        center_nav: true,
      },
    },
  ],
};

export default new Router({
  mode: 'history',
  routes: [
    auth,

    main,
  ],
});
